// Shared index rule for prerender.js (Node require) and the React app.
// Thresholds live in src/data/seoIndexRules.json; mirrored in backend/core/seo_rules.py.
const RULES = require("../data/seoIndexRules.json");

function milesBetween(lat1, lng1, lat2, lng2) {
  const rad = (d) => (d * Math.PI) / 180;
  const dLat = rad(lat2 - lat1);
  const dLng = rad(lng2 - lng1);
  const a = Math.sin(dLat / 2) ** 2 + Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * 3958.8 * Math.asin(Math.sqrt(a));
}

function inIndexRegion(p) {
  if (RULES.placeStates.includes(String(p.state || "").toUpperCase())) return true;
  if (typeof p.lat !== "number" || typeof p.lng !== "number") return false;
  return RULES.placeRegions.some((r) => milesBetween(r.lat, r.lng, p.lat, p.lng) <= r.radiusMiles);
}

function hasPhoto(p) {
  if (p.photo_ref) return true;
  const first = Array.isArray(p.photos) ? p.photos[0] : null;
  return !!(first && typeof first === "object" && first.ref);
}

// pawgroundReviewCount overrides p.pawground_review_count when the caller has a fresher number.
function isPlaceIndexable(p, pawgroundReviewCount) {
  if (!p || p.business_status === "CLOSED_PERMANENTLY") return false;
  if (p.source === "community") return true;
  const pg = typeof pawgroundReviewCount === "number" ? pawgroundReviewCount : p.pawground_review_count || 0;
  if (pg >= RULES.anyPlaceMinPawgroundReviews) return true;
  if (!inIndexRegion(p)) return false;
  if (RULES.placeRequirePhoto && !hasPhoto(p)) return false;
  return (p.rating || 0) > RULES.placeMinRatingExclusive && (p.user_rating_count || 0) >= RULES.placeMinGoogleReviews;
}

function isHubIndexable(placeCount) {
  return (placeCount || 0) >= RULES.hubMinPlaces;
}

module.exports = { SEO_INDEX_RULES: RULES, isPlaceIndexable, isHubIndexable };
